<template>
  <div class="record-set">
    <template v-for="(plan, index) in showPlanList" :key="index">
      <div class="record">
        <div class="content">
          <template v-for="field in plan.list" :key="field.detailId">
            <div class="field">
              <div class="customer-info">
                <h4 class="info-title">{{ field.taskContent }}</h4>
                <div class="info-detail">
                  <div class="detail-label">
                    <i class="icon-calendar-schedule-line t-iconfont"></i>
                    <span class="label-text">推荐拜访时间：</span>
                  </div>
                  <span class="detail-value">{{ showTime(field.recommendTime) }}</span>
                </div>
                <div class="suggestion-references">
                  <ReferenceCard
                    v-for="(item, evidenceIndex) in field.evidence || []"
                    :key="`${item.fileName}-${evidenceIndex}`"
                    :file-name="item.fileName"
                  />
                </div>
              </div>
              <div class="selector">
                <p class="selector-text">{{ field.recommendReason }}</p>
              </div>
              <div class="action-group">
                <button class="btn ignore-btn" @click="handleIgnore(field)">
                  <i class="btn-icon icon-eye-off-line t-iconfont"></i>
                  <span class="btn-text">忽略</span>
                </button>
                <button class="add-plan-btn btn" @click="toCreate(field)">
                  <i class="btn-icon icon-briefcase-ai-line t-iconfont"></i>
                  <span class="btn-text">加入访客计划</span>
                </button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
    <div v-if="aiRecommendPlan.length > 3 && !showAll" class="load-more-wrapper">
      <div class="load-more-btn" @click="showAll = true">加载更多</div>
    </div>
  </div>
</template>

<script setup>
import xbb from '@xbb/xbb-utils'
import { ignorePlan } from '@/api/app-home'
import AppMessage from '@/components/message/index.js'
import { computed, ref } from 'vue'
import ReferenceCard from '@/components/reference-card/index.vue'

defineOptions({
  name: 'ChatRecommendCard'
})

const props = defineProps({
  aiRecommendPlan: {
    type: Array,
    default: () => []
  }
})

const emits = defineEmits(['toCreate', 'ignore'])

const showAll = ref(false) // 默认最多3条，如果大于三，超出显示加载更多

const showPlanList = computed(() => {
  if (showAll.value) return props.aiRecommendPlan
  return props.aiRecommendPlan.slice(0, 3)
})

const showTime = (time) => {
  return xbb.formatTime(time, 'yyyy-MM-dd HH:mm:ss')
}

const toCreate = (field) => {
  emits('toCreate', field)
}

const handleIgnore = (field) => {
  ignorePlan({
    detailId: field.detailId
  }).then(() => {
    AppMessage.success('操作成功')
    emits('ignore', field)
  })
}
</script>

<style lang="scss" scoped>
.record-set {
  .record {
    display: flex;

    .step-bar {
      width: 14px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 8px;

      .step-icon {
        width: 14px;
        height: 14px;
        color: #969799;
        margin-top: 8px;
        margin-bottom: 8px;

        .icon {
          width: 10.5px;
          height: 11.65px;
        }
      }

      .step-line {
        flex: 1;
        width: 1px;
        background-color: #f2f3f5;
      }
    }

    .content {
      flex: 1;

      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 8px;
        margin-bottom: 8px;

        .follow-info {
          .follow-time {
            line-height: 16px;
            font-size: 12px;
            color: #323233;
          }
        }

        .action {
          display: flex;
          align-items: center;

          .action-text {
            line-height: 16px;
            font-size: 12px;
            color: #969799;
            margin-right: 4px;
          }

          i {
            font-size: 14px;
            color: #969799;
          }
        }
      }

      .field {
        background-color: #f7f8fa;
        border: 1px solid #f2f3f5;
        border-radius: 12px;
        padding: 12px;
        margin-bottom: 8px;

        .customer-info {
          margin-bottom: 12px;

          .info-title {
            font-size: 14px;
            font-weight: 500;
            color: #323233;
            margin: 0 0 4px 0;
          }

          .info-detail {
            display: flex;
            align-items: center;

            .detail-label {
              display: flex;
              align-items: center;
              i {
                font-size: 12px;
                color: #969799;
                margin-right: 4px;
              }

              .label-text {
                font-size: 12px;
                color: #969799;
                line-height: 16px;
              }
            }

            .detail-value {
              font-size: 12px;
              color: #323233;
            }
          }
          .suggestion-references {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            margin-top: 8px;
          }
        }

        .selector {
          background: linear-gradient(289deg, #eef2ff 1%, #f5f3ff 100%);
          border: 1px solid #f5e8ff;
          border-radius: 12px;
          padding: 12px;
          margin-bottom: 12px;

          .selector-text {
            font-size: 13px;
            color: #323233;
            margin: 0;
            line-height: 1.4;
          }
        }

        .action-group {
          display: flex;

          .btn {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid;
            border-radius: 64px;
            padding: 8px 12px;
            background: transparent;
            cursor: pointer;

            &:first-child {
              margin-right: 12px;
            }

            .btn-icon {
              display: flex;
              align-items: center;
              width: 14px;
              height: 14px;
              margin-right: 8px;
            }

            .btn-text {
              font-size: 13px;
            }
          }

          .ignore-btn {
            border-color: #e5e6eb;

            .btn-icon,
            .btn-text {
              color: #646566;
            }
          }

          .add-plan-btn {
            border-color: #7a52f4;

            .btn-icon,
            .btn-text {
              color: #7a52f4;
            }
          }
        }
      }
    }
  }
  .load-more-wrapper {
    .load-more-btn {
      font-size: 14px;
      line-height: 20px;
      color: #248df5;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
